import { Callout } from "@/components/ui";

export const CiqAllergyNoKnown = () => (
  <Callout
    variant="ai"
    subtle
    title="Allergies Auto-charted"
    description="The patient's allergy list was auto-charted as No Known Drug Allergies. Review and confirm the allergy list."
  />
);
